<template>
  <v-container>
    <v-row>
      <v-col sm="10">
        <h4 class="white--text">Project Collaborators</h4>
      </v-col>
      <v-col sm="2">
        <div
          :class="{ paddingT10: collabToggle }"
          @click="collabToggle = !collabToggle"
        >
          <v-icon
            class="cursorPointer"
            color="white"
            size="25"
            v-if="!collabToggle"
            :data-test-id="`${dataTestId}__open-icon`"
            >add</v-icon
          >
          <v-icon
            class="cursorPointer"
            color="white"
            size="25"
            v-if="collabToggle"
            :data-test-id="`${dataTestId}__close-icon`"
            >maximize</v-icon
          >
        </div>
      </v-col>
    </v-row>
    <transition name="slideUp">
      <div v-if="collabToggle">
        <v-row>
          <v-col sm="12">
            <ul class="collaborator-list" v-if="collaboratorsList.length" :data-test-id="`${dataTestId}__collab-list`">
              <li
                v-for="(item, index) in collaboratorsList"
                :key="index"
                @click.stop
                :data-test-id="`${dataTestId}__collab-list-item-${index+1}`"
              >
                <v-row>
                  <v-col sm="10" class="py-0">{{ getName(item) }}</v-col>
                  <v-col sm="2" class="py-0 text-right">
                    <v-icon
                      v-if="
                        projectDetails.projectStatus !==
                          $enums.projectStatus.ARCHIVED
                      "
                      class="cursorPointer"
                      color="primary"
                      @click.prevent="removeCollaboratorStart(item)"
                      :data-test-id="`${dataTestId}__collab-list-item-${index+1}-close-icon`"
                      >close</v-icon
                    >
                  </v-col>
                </v-row>
              </li>
            </ul>
            <x-dialog
              :dialogTitle="'Confirm Delete?'"
              :confirmDialog="true"
              :dialogState="removeCollabDialogue"
              @toggleModal="closeDialog"
              :actions="{
                show: true,
                secondaryButtonFunction: closeDialog,
                primaryButtonFunction: removeCollaborator,
                primaryButtonShow: true,
                secondaryButtonText: 'Cancel',
                primaryButtonText: 'Confirm'
              }"
              :data-test-id="`${dataTestId}__confirm-project-collab-btn`"
            />
            <span v-if="!collaboratorsList.length"
              >No collaborators for this project</span
            >
          </v-col>
        </v-row>
        <v-row v-if="projectDetails">
          <v-col sm="12" class="text-right">
            <v-btn
              color="#1B2342"
              small
              :ripple="false"
              class="white--text"
              @click="toggleAddCollaborator"
              v-if="
                projectDetails.projectStatus !==
                  $enums.projectStatus.ARCHIVED && allCollabArr.length
              "
              :data-test-id="`${dataTestId}__add-new-collab-btn`"
              >Add new</v-btn
            >
            <addNewCollab
              v-if="openAddCollab"
              :dialogOpen="openAddCollab"
              @closeOverlay="toggleAddCollaborator"
              :allUserArr="allCollabArr"
              :collaboratorsList="collaboratorsList"
              :allUserObj="allCollabObj"
            />
          </v-col>
        </v-row>
      </div>
    </transition>
  </v-container>
</template>

<script>
import addNewCollab from '@/components/Discovery/AddNewCollaboratorDialog';
import ProjectService from '../../../services/ProjectService';
import UserService from '../../../services/UserService';
import EventBus from '@/EventBus';

export default {
  data() {
    return {
      collabToggle: true,
      openAddCollab: false,
      removeCollabDialogue: false,
      toRemoveCollab: null,
      archivedProject: true,
      userArrCustom: [],
      allCollabObj: null,
      allCollabArr: []
    };
  },
  props: {
    projectDetails: Object,
    allTags: Array,
    collaboratorsList: Array,
    allUserArr: Array,
    allUserObj: Object,
    dataTestId:String
  },
  components: {
    addNewCollab
  },
  created() {
    // get all collaborators
    this.getAllCollaborators();
  },
  methods: {
    async getAllCollaborators() {
      let collabs = await UserService.loadUsersAll(true, true);
      collabs = collabs.data.body[0].results;
      collabs.forEach(user => {
        user['text'] = user.firstName;
        user['value'] = user.id;
      });
      this.allCollabArr = collabs;
      this.allCollabObj = this.formatUsers(collabs);
    },
    closeDialog() {
      this.removeCollabDialogue = false;
    },
    formatUsers(userList) {
      let allUserObj = {};
      userList.forEach(user => {
        allUserObj[user.id] = user;
      });
      return allUserObj;
    },
    getName(objUser) {
      let name = '';
      if (objUser.firstName) {
        name = objUser.firstName;
        if (objUser.lastName) {
          name += ' ' + objUser.lastName;
        }
      }
      return name;
    },
    toggleAddCollaborator() {
      this.openAddCollab = !this.openAddCollab;
    },
    removeCollaboratorStart(collab) {
      this.toRemoveCollab = collab;
      this.removeCollabDialogue = true;
    },
    async removeCollaborator() {
      try {
        await ProjectService.removeCollaborators(this.$route.params.projectId, [
          this.toRemoveCollab.id
        ]);
        EventBus.$emit('REFRESH_COLLABORATORS', true);
        this.snackbar('success', this.$message.COLLAB_REMOVED);
      } catch (err) {
        let errData = err.response.data;
        if (errData.errors) {
          this.snackbar('error', errData.errors[0].message);
        } else {
          this.snackbar('error', err);
        }
      } finally {
        this.removeCollabDialogue = false;
      }
    }
  }
};
</script>

<style scoped>
.collaborator-list {
  list-style: none;
  padding: 0;
  width: 100%;
  margin: 0;
}

.collaborator-list li {
  padding: 10px !important;
  background: white;
  margin-bottom: 10px;
}

.collaborator-list li p {
  color: #1b2342;

  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  text-align: left;
  margin: 0;
  display: inline-block;
  width: 100%;
}

.collaborator-list li i {
  font-size: 15px;
}
</style>
